import { Avatar, AvatarProps, BodyText, Caption } from '@farol-ds/react'

import styles from './social-proof.module.scss'

const avatars: AvatarProps[] = [
  {
    alt: 'A M',
    size: 'lg',
  },
  {
    alt: 'C S',
    size: 'lg',
  },
  {
    alt: 'L R',
    size: 'lg',
  },
  {
    alt: 'J P',
    size: 'lg',
  },
  {
    alt: '+',
    size: 'lg',
    color: 'neutral',
  },
]

export const SocialProof = () => {
  return (
    <div className={styles.container}>
      <div className={styles.avatars}>
        {avatars.map((avatar) => (
          <Avatar key={avatar.alt} className={styles.avatar} {...avatar} />
        ))}
      </div>

      <div className={styles.text}>
        <BodyText size="md">
          <b>Mais de 900 mil assinantes</b>
        </BodyText>
        <Caption>confiam no Jusbrasil.</Caption>
      </div>
    </div>
  )
}
